var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_285)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0.882812C32.3142 0.882812 41.5 10.0686 41.5 21.3828C41.5 32.6971 32.3142 41.8828 21 41.8828C9.68576 41.8828 0.5 32.6971 0.5 21.3828C0.5 10.0686 9.68576 0.882812 21 0.882812ZM14.5908 32.9037V16.8944H9.26847V32.9037H14.5908ZM33.7791 32.9037V23.7231C33.7791 18.8056 31.1536 16.518 27.6524 16.518C24.8293 16.518 23.5647 18.0706 22.8566 19.1611V16.8944H17.5357C17.6062 18.3965 17.5357 32.9037 17.5357 32.9037H22.8565V23.963C22.8565 23.4845 22.891 23.0061 23.032 22.6641C23.416 21.7083 24.2922 20.7182 25.7622 20.7182C27.6868 20.7182 28.4579 22.1869 28.4579 24.3381V32.9037H33.7791ZM11.9656 9.1749C10.1446 9.1749 8.95489 10.3721 8.95489 11.9412C8.95489 13.4773 10.1084 14.7074 11.8951 14.7074H11.9295C13.7853 14.7074 14.9404 13.4773 14.9404 11.9412C14.906 10.3721 13.7854 9.1749 11.9656 9.1749Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(0.5 0.882812)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/li.98926b1821581616d1ce41644bf66a18.svg";
export { ForwardRef as ReactComponent };